import './../css/Groups.css';
import {useDispatch} from "react-redux";
import {setCatProductAction} from "../store/actions/productActions";

function CrmGroupListItem({id, name, children, subGroup}) {

    const dispatch = useDispatch();

    function setCatProductFilter(id) {
        dispatch(setCatProductAction(id))
    }

    return (
        <div className="GroupListItem">
            <div className="GroupItemName"
                 id={'item-'+id}
                 onClick={() =>setCatProductFilter(id) }>
                {name}
            </div>
            <div className="GroupSubList" id={'cont-'+id}>
                {children.map((child) => (
                    <CrmGroupListItem
                        key={ child.id }
                        id={ child.id }
                        name={ child.name }
                        children={ child.children }
                        subGroup={child.subGroup}
                    />
                ))}
            </div>
        </div>
    );
}

export default CrmGroupListItem;


